import React from 'react';
import './Auth.scss';

const AuthLayout = ({ children }: any) => {
  return (
    <div className="authContainer">
      <div className="container-auth">
        <div className="authpage">
          
          <div className="authRight">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
